module.exports = __webpack_public_path__ + "media/images/subscribe-icon-corporate-6cc3ec50.svg";